<template>
  <BreadCrumb v-if="route.meta.requiresAuth"
              :home="home" 
              :model="route.meta.breadcrumb"
              class="bg-transparent p-1 mb-2">
    <template #item="{ item, props}">
      <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
        <a :href="href" v-bind="props.action" @click="navigate">
          <span :class="[item.icon, 'text-primary']"></span>
          <span class="text-primary">{{ item.label }}</span>
        </a>
      </router-link>
      <a v-else :href="item.url" :target="item.target" v-bind="props.action">
        <span class="">{{ item.label }}</span>
      </a> 
    </template>          
  </BreadCrumb>
  <div class="header" id="header-section">
    <h1 class="mb-0" id="header-caption">{{ route.meta.title }}</h1>
    <p class="mb-0 mt-1 instructions" v-if="route.meta.instructions?.length > 0">{{ route.meta?.instructions }}</p>
  </div>
</template>

<script setup>
import BreadCrumb from 'primevue/breadcrumb';
import { ref }  from 'vue';
import { useRoute } from 'vue-router';
import { usePageTitle } from '@/composables/pageTitle';
import { ICONS } from '@/utils/constants';

usePageTitle();

const route = useRoute();
const home = ref({ label: 'Home', icon: ICONS.Home, route: '/' });

defineProps({
    showBreadcrumb: {
        type: Boolean,
        default: true
    }
});

</script>

<style lang="scss">

.header {
  padding-inline: 1rem;
  padding-block: .25rem 1rem;
  border-bottom: 2px solid var(--p-primary-color);
  margin-bottom: 1rem;
}

.instructions {
  color: rgb(75, 75, 75)
}

</style>


